import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';

import Wrapper from '../../components/Wrapper';
import PaginationComponent from '../../components/PaginationComponent';
import PartnersTable from '../../components/tables/PartnersTable';

import {
  setCurrentPage,
} from '../../store/features/partnersSlice';
import { fetchPartners } from '../../store/features/partnersSlice';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';

const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const {
    partners,
    currentPage,
    totalPages,
    status,
    source,
    searchKeyword,
  } = useSelector((state) => state.partners);

  useEffect(() => {
    dispatch(fetchPartners({ page: currentPage, limit: 50 }));
  }, [currentPage, dispatch]);

  const filteredPartners = useMemo(() => {
    const keyword = searchTerm.trim().toLowerCase();
    if (!keyword) return partners;

    return partners.filter((partner) => {
      return (
        partner?.entity_name?.toLowerCase().includes(keyword) ||
        partner?.admin_id?.toLowerCase().includes(keyword)
      );
    });
  }, [partners, searchTerm]);

  return (
    <Wrapper>
      <div className='reports-container py-4 w-100'>
      <div className='d-flex flex-column flex-lg-row justify-content-between align-items-center mb-3 w-100'>

        <h1 className='fw-bolder'>Partners</h1>

        <div className="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center gap-3 mt-3 mt-md-0 w-100 justify-content-lg-end">

          <Form.Control
            type="text"
            placeholder="Search partner"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="flex-grow-1"
            style={{ maxWidth: "380px" }}
          />

          <div className="d-flex gap-2 flex-shrink-0">
            <button
              className="btn btn-dark text-nowrap"
              onClick={() => navigate('/partner/inquiry')}
            >
              <FaPlus /> Inquiries
            </button>

            <button
              className="btn btn-dark text-nowrap"
              onClick={() => navigate('/partner/add-partner')}
            >
              <FaPlus /> Add Partner
            </button>
          </div>

        </div>

      </div>

        {status === 'succeeded' ? (
          <>
            <PartnersTable partners={filteredPartners} startIndex={(currentPage - 1) * 50 + 1} />
            <PaginationComponent
              currentPage={currentPage}
              totalPages={totalPages}
              fetchData={fetchPartners}
              source={source}
              searchKeyword={searchKeyword}
              onPageChange={(pageNum) => dispatch(setCurrentPage(pageNum))}
            />
          </>
        ) : (
          <h2 className=''>Loading...</h2>
        )}
      </div>
    </Wrapper>
  );
};

export default Users;